import { render, staticRenderFns } from "./job-setup-area-browser.component.vue?vue&type=template&id=7f1135f8"
import script from "./job-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
export * from "./job-setup-area-browser.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job-setup-area-browser.component.vue?vue&type=style&index=0&id=7f1135f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports